import { render, staticRenderFns } from "./navjxshany.vue?vue&type=template&id=49e26908&scoped=true&"
import script from "./navjxshany.vue?vue&type=script&lang=js&"
export * from "./navjxshany.vue?vue&type=script&lang=js&"
import style0 from "./navjxshany.vue?vue&type=style&index=0&id=49e26908&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e26908",
  null
  
)

export default component.exports